import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform(cars: any): any {
    if (!cars) {
      return cars;
    }
    return cars.sort((a, b) => a.make.localeCompare(b.make));
  }
}
